import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
// zustand store for geofences
import alertsSlices, { type AlertsSlices } from './slices';

const devtoolsInstance = devtools(alertsSlices, { name: 'useTriggersStore' });

const useTriggersStore = create<AlertsSlices, [['zustand/devtools', never]]>(devtoolsInstance);

export default useTriggersStore;
